export default __webpack_public_path__ + "static/media/rso.e249b6fc.pdf";